import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Button, Icon, notification, Modal, Select } from "antd";
import axios from "axios";
import moment from "moment";

import SelectDisciplinas from "../componentes/SelectDisciplinas";

const { Option } = Select;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class ExcelTabelaConteudosMobile extends Component {
    state = {
        disciplinaId: localStorage.getItem("vista") === "TURMA" ? undefined : localStorage.getItem("codigo_curso"),
        //FILTROS
        disciplinas: [],
        disciplinasId: [],
        disciplinaNome: "",
        isSelected: false,
        opcao: "",
        num: 1,
        total: 0,
        semPeriodos: false,
        periodos: [],
        //PESQUISA
        dt_inicio: "",
        dt_fim: "",
        //PERIODO
        mes: "",
        ano: "",
        titulo: "",
        aulas: [],
        //LOADING
        iconLoading: false,
        //TITULOS
        campoConteudos: null,
        campoHabilidades: null,
        campoMetodologia: null,
        campoAprendizagemMatutina: null,
        campoAprendizagemVespertina: null
    };

    componentDidMount() {
        if (localStorage.getItem("vista") === "TURMA") this.listarDisciplinas();

        this.total();
        this.titulosDetalhe();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.setState(
                {
                    disciplinaId: localStorage.getItem("vista") === "TURMA" ? undefined : localStorage.getItem("codigo_curso")
                },
                () => {
                    if (localStorage.getItem("vista") === "TURMA") this.listarDisciplinas(true);

                    this.total();
                    this.titulosDetalhe();
                }
            );
        }
    }

    selectDiscipline = opcao => {
        this.setState({
            isSelected: true
        });
        this.handleSelect(opcao);
    };

    handleSelect = opcao => {
        let disciplinaId = opcao;
        if (opcao === "Todos") {
            this.setState(
                {
                    disciplinaId,
                    todos: opcao === "Todos"
                },
                () => this.listar(true)
            );
        } else {
            if (disciplinaId) {
                this.props.setDisciplinaId(disciplinaId);
                this.setState(
                    {
                        disciplinaId,
                        disciplinaNome: this.state.disciplinas.find(f => f.id === disciplinaId)?.nome
                    },
                    () => this.listar(true)
                );
            } else {
                this.setState({
                    aulas: []
                });
            }
        }
    };

    total = () => {
        //this.setState({
        //    iconLoading: true
        //}, () => {
        axios({
            method: "get",
            url: "/api/aulas/total-periodos-conteudos",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                if (response.data.length > 0) {
                    this.setState(
                        {
                            total: response.data.length,
                            periodos: response.data,
                            titulo: response.data[0].titulo,
                            dt_inicio: response.data[0].dt_inicio,
                            dt_fim: response.data[0].dt_fim
                        },
                        () => {
                            if (!localStorage.getItem("vista")) this.listar();

                            this.props.carregarPeriodoId(response.data[0].id);
                        }
                    );
                } else {
                    this.setState({
                        semPeriodos: true
                        //iconLoading: false
                    });
                    openNotificationWithIcon("warning", "Atenção", "Não foram adicionados períodos ao curso!");
                }
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
            });
        //})
    };

    listar = () => {
        this.setState(
            {
                iconLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/aulas/listar-conteudos",
                    params: {
                        id: this.state.disciplinaId == "Todos" ? localStorage.getItem("codigo_curso") : this.state.disciplinaId,
                        dt_inicio: this.state.dt_inicio,
                        dt_fim: this.state.dt_fim
                    }
                })
                    .then(response => {
                        this.setState({
                            aulas: response.data,
                            iconLoading: false
                        });
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
                    });
            }
        );
    };

    listarDisciplinas = multisseriado => {
        axios({
            method: "get",
            url: "/api/aulas/listar-turma-disciplinas",
            params: {
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                let disciplinaId = undefined;

                if (this.state.disciplinaNome) {
                    const disciplinaNomeFormatado = this.state.disciplinaNome.toLowerCase().trim();
                    disciplinaId = response.data.find(disc => disc.nome.toLowerCase().trim() === disciplinaNomeFormatado)?.id;
                }

                this.setState(
                    {
                        disciplinaId,
                        disciplinas: response.data,
                        iconLoading: false,
                        disciplinasId: response.data.map(e => e.id)
                    },
                    () => {
                        if (this.state.disciplinaId !== undefined) {
                            this.listar(true);
                            this.props.setDisciplinaId(this.state.disciplinaId);
                        }
                    }
                );
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar as disciplinas!");
            });
    };

    titulosDetalhe = () => {
        axios({
            method: "get",
            url: "/api/aulas/titulos-conteudo",
            params: {
                id: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { conteudos, habilidades, metodologias, aprendizagemMatutina, aprendizagemVespertina } = response.data;

                this.setState({
                    campoConteudos: conteudos,
                    campoHabilidades: habilidades,
                    campoMetodologia: metodologias,
                    campoAprendizagemMatutina: aprendizagemMatutina,
                    campoAprendizagemVespertina: aprendizagemVespertina
                });
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", "Não foi possível carregar a aula!");
            });
    };

    anteriorProximo = num => {
        let periodo = this.state.periodos[num - 1];

        this.setState(
            {
                num,
                titulo: periodo.titulo,
                dt_inicio: periodo.dt_inicio,
                dt_fim: periodo.dt_fim
            },
            () => {
                this.listar();
                this.props.carregarPeriodoId(periodo.id);
            }
        );
    };

    proximaDisciplina = disciplinaId => {
        const disciplinas = this.state.disciplinas.map(e => e.id);

        let nextValue = disciplinas[disciplinas.indexOf(disciplinaId) + 1];

        this.handleSelect(nextValue);
        this.anteriorProximo(1);
    };

    anteriorDisciplina = disciplinaId => {
        const disciplinas = this.state.disciplinas.map(e => e.id);

        let periodosLength = this.state.periodos.length;

        let previousValue = disciplinas[disciplinas.indexOf(disciplinaId) - 1];

        this.handleSelect(previousValue);
        this.anteriorProximo(periodosLength);
    };

    render() {
        const {
            disciplinaId,
            //FILTROS
            disciplinas,
            isSelected,
            num,
            semPeriodos,
            periodos,
            //PERIODO
            titulo,
            aulas,
            //LOADING
            iconLoading,
            //TITULOS
            campoConteudos,
            campoHabilidades,
            campoMetodologia,
            campoAprendizagemMatutina,
            campoAprendizagemVespertina
        } = this.state;

        return (
            <>
                <div>
                    <div className="bloco-controlos-frequencia-2">
                        <div className="filters">
                            <div>
                                <SelectDisciplinas
                                    disciplinas={disciplinas}
                                    onChange={this.selectDiscipline}
                                    visible={localStorage.getItem("vista") === "TURMA"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="bloco-controlos-frequencia">
                        <div className="filters">
                            <div>
                                {!semPeriodos && (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        {isSelected === false && typeof disciplinaId === "number" ? (
                                            <>
                                                <Button
                                                    className="botao-periodo botao-periodo-anterior"
                                                    disabled={num === 1}
                                                    style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                                    onClick={() => {
                                                        this.anteriorProximo(num - 1);
                                                    }}
                                                >
                                                    <Icon type="left" />
                                                </Button>
                                                <span>{titulo}</span>
                                                <Button
                                                    className="botao-periodo botao-periodo-proximo"
                                                    disabled={
                                                        num === periodos.length ||
                                                        (localStorage.getItem("vista") === "TURMA" && !disciplinaId)
                                                    }
                                                    style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                                    onClick={() => {
                                                        this.anteriorProximo(num + 1);
                                                    }}
                                                >
                                                    <Icon type="right" />
                                                </Button>{" "}
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    className="botao-periodo botao-periodo-anterior"
                                                    disabled={num === 1}
                                                    style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                                    onClick={() => this.anteriorProximo(num - 1)}
                                                >
                                                    <Icon type="left" />
                                                </Button>
                                                <span>{titulo}</span>
                                                <Button
                                                    className="botao-periodo botao-periodo-proximo"
                                                    disabled={
                                                        num === periodos.length ||
                                                        (localStorage.getItem("vista") === "TURMA" && !disciplinaId)
                                                    }
                                                    style={{ color: "rgba(0, 0, 0, 0.8)" }}
                                                    onClick={() => this.anteriorProximo(num + 1)}
                                                >
                                                    <Icon type="right" />
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                )}
                                <div>
                                    Sumário e/ou Frequência por preencher:{" "}
                                    <strong>{aulas.filter(x => x.estado === "POR_REALIZAR").length}</strong>
                                </div>
                            </div>
                        </div>
                    </div>

                    {aulas.map(aula => (
                        <div key={aula.id} className="bloco-diario-observacoes">
                            <div
                                className="observacao-data-aula"
                                style={
                                    aula.cor === "white"
                                        ? {
                                              background: aula.cor,
                                              border: "1px solid black",
                                              color: "black"
                                          }
                                        : {
                                              background: aula.cor,
                                              color: aula.cor === "#3d464d" ? "white" : ""
                                          }
                                }
                            >
                                {aula.curso && <span>{aula.curso}</span>}
                                <span>
                                    {aula.titulo?.trim() && (
                                        <>
                                            {aula.titulo} <i className="fas fa-circle separador-data-hora"></i>{" "}
                                        </>
                                    )}
                                    {moment(aula.dt_inicio).format("DD/MM/YYYY")} <i className="fas fa-circle separador-data-hora"></i>{" "}
                                    {aula.hr_inicio} - {aula.hr_termino}
                                </span>
                            </div>
                            <div style={{ padding: "10px 20px 20px" }}>
                                {!aula.conteudo &&
                                    !aula.conceitos &&
                                    !aula.metodologia &&
                                    !aula.aprendizagem_matutina &&
                                    !aula.aprendizagem_vespertina && <p>Sem dados...</p>}
                                {aula.conteudo && campoConteudos?.visivel && (
                                    <div>
                                        <label style={{ borderBottom: "1px solid #a6c8d5", paddingBottom: 3, fontWeight: "600" }}>
                                            {campoConteudos?.titulo}
                                        </label>
                                        <p style={{ marginTop: 10 }}>{aula.conteudo}</p>
                                    </div>
                                )}
                                {aula.conceitos && campoHabilidades?.visivel && (
                                    <div>
                                        <label style={{ borderBottom: "1px solid #a6c8d5", paddingBottom: 3, fontWeight: "600" }}>
                                            {campoHabilidades?.titulo}
                                        </label>
                                        {aula.conceitos.split(";").map((conceito, index) => (
                                            <p key={index} style={{ marginTop: 10 }}>
                                                {conceito}
                                            </p>
                                        ))}
                                    </div>
                                )}
                                {aula.metodologia && campoMetodologia?.visivel && (
                                    <div>
                                        <label style={{ borderBottom: "1px solid #a6c8d5", paddingBottom: 3, fontWeight: "600" }}>
                                            {campoMetodologia?.titulo}
                                        </label>
                                        <p style={{ marginTop: 10, whiteSpace: "pre-line" }}>{aula.metodologia}</p>
                                    </div>
                                )}
                                {aula.aprendizagem_matutino && campoAprendizagemMatutina?.visivel && (
                                    <div>
                                        <label style={{ borderBottom: "1px solid #a6c8d5", paddingBottom: 3, fontWeight: "600" }}>
                                            {campoAprendizagemMatutina?.titulo}
                                        </label>
                                        <p style={{ marginTop: 10, whiteSpace: "pre-line" }}>{aula.aprendizagem_matutino}</p>
                                    </div>
                                )}
                                {aula.aprendizagem_vespertino && campoAprendizagemVespertina?.visivel && (
                                    <div>
                                        <label style={{ borderBottom: "1px solid #a6c8d5", paddingBottom: 3, fontWeight: "600" }}>
                                            {campoAprendizagemVespertina?.titulo}
                                        </label>
                                        <p style={{ marginTop: 10, whiteSpace: "pre-line" }}>{aula.aprendizagem_vespertino}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                    {aulas.length === 0 && <span>Sem dados...</span>}
                </div>
                <Modal visible={iconLoading} maskClosable={false} className="modal-loading" footer={null} closable={false}>
                    <div className="modal-loading-bloco">
                        <p>
                            <Icon type="loading" />
                        </p>
                        <p className="texto">A carregar...</p>
                    </div>
                </Modal>
            </>
        );
    }
}

export default withRouter(ExcelTabelaConteudosMobile);
